'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/AlertFailure.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertFailure = function AlertFailure(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    {
      className: 'alert alert-danger cp-alert-failure', role: 'alert',
      'aria-live': 'polite', 'aria-atomic': 'true' },
    _react2.default.createElement(_baseIcons.Failure, { name: 'Failure' }),
    children
  );
};

AlertFailure.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

exports.default = AlertFailure;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/failure/components/AlertFailure.component.js
// module id = 359
// module chunks = 0 1 4